import moment from "moment-timezone";

export const convertToISTDate = (isoDateTime) => {
  const dateTimeInUTC = moment.utc(isoDateTime);
  return dateTimeInUTC.tz("Asia/Kolkata").format("D MMM YYYY");
};

export const convertToISTDateTime = (isoDateTime) => {
  const dateTimeInUTC = moment.utc(isoDateTime);
  return dateTimeInUTC.tz("Asia/Kolkata").format("D MMM YYYY, h:mm:ss A");
};
